export default {"src":"/_next/static/media/icon_favourite_default.e074cf3e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};